module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"a-healing-home\"-in-inglewood-california-9420f26f61f3f859cf5add20f325d8eb.png";